import { toSafeString } from '@shared/utils';

const normalizeMemberRoleId = (member = {}) => {
  return toSafeString(member?.roleId || member?.role_id || member?.role?.id || member?.role?.roleId || member?.role?.role_id);
};

export default normalizeMemberRoleId;
